import { ConfirmModal } from '@/components/ConfirmModal/ConfirmModal';
import { ORG_ADMIN_ROLE, OrgAdminRoleType } from '@/const/user';

type UpdateAdminRoleModalType = {
  isOpen: boolean;
  role: OrgAdminRoleType;
  onClose: () => void;
  onConfirm: () => void;
  isLoading?: boolean;
};

export const EditAdminRoleModal = ({ isOpen, role, onClose, onConfirm, isLoading }: UpdateAdminRoleModalType) => {
  const header = role === ORG_ADMIN_ROLE.MASTER_ADMIN ? 'Upgrade User Role' : 'Downgrade User Role';
  const body =
    role === ORG_ADMIN_ROLE.MASTER_ADMIN
      ? 'The User will be responsible for their organization management.'
      : 'The User will not be able to manage their organization settings.';

  return (
    <ConfirmModal
      isOpen={isOpen}
      header={header}
      body={body}
      onClose={onClose}
      onConfirm={onConfirm}
      isLoading={isLoading}
    />
  );
};
